export function getUserThemePrefers(): "light" | "dark" {
    const localTheme = localStorage.getItem("theme");
    if (localTheme) return localTheme as "light" | "dark";
    if (typeof window !== "undefined") {
        return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
    }
    return "light";
}